/**
 * Lazy loader for the `<yom-report>` web component.
 *
 * The bundle (~9 KB gz) is served by YOM itself (docs/embed.md §2). It is only
 * fetched when an analytics page mounts a report, never in the app shell, so
 * it cannot touch LCP for the rest of the admin. One <script> per tab, ever.
 *
 * Pin a version in production with VITE_YOM_EMBED_SRC
 * (e.g. https://yom.aapastech.com/app/cdn/embed/0.2.0/yom-report.iife.js).
 */
export const DEFAULT_YOM_EMBED_SRC =
  'https://yom.aapastech.com/app/cdn/embed/latest/yom-report.iife.js';

export function yomEmbedSrc(): string {
  return (import.meta.env.VITE_YOM_EMBED_SRC as string | undefined) || DEFAULT_YOM_EMBED_SRC;
}

let loading: Promise<void> | null = null;

export function loadYomEmbed(src: string = yomEmbedSrc()): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.customElements?.get('yom-report')) return Promise.resolve();
  if (loading) return loading;

  loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.dataset.yomEmbed = 'report';
    script.onload = () => {
      window.customElements
        .whenDefined('yom-report')
        .then(() => resolve())
        .catch(reject);
    };
    script.onerror = () => {
      script.remove();
      loading = null; // allow a retry
      reject(new Error('Could not load the analytics component'));
    };
    document.head.appendChild(script);
  });
  return loading;
}
